import { render, staticRenderFns } from "./comment-list.vue?vue&type=template&id=1a4198d2&scoped=true&lang=html&"
import script from "./comment-list.vue?vue&type=script&lang=js&"
export * from "./comment-list.vue?vue&type=script&lang=js&"
import style0 from "./comment-list.vue?vue&type=style&index=0&id=1a4198d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4198d2",
  null
  
)

export default component.exports